// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ResetAnnotationOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 576 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M97 319a23.9 23.9 0 000 33.9l72 72c4.5 4.5 10.6 7 17 7h108.1c6.4 0 12.5-2.5 17-7l65-65L216 200 97 319zM285.1 63a72 72 0 01101.8 0L513 189.1a72 72 0 010 101.8L371.9 432H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H185.9c-19.1 0-37.4-7.6-50.9-21.1l-72-72a72 72 0 010-101.8L285.1 63z"}}]},"name":"reset-annotation","theme":"outlined"};

const ResetAnnotationOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ResetAnnotationOutlinedSvg} />;
  ResetAnnotationOutlined.displayName = 'ResetAnnotationOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ResetAnnotationOutlined);
